import { IUserAuthenticationService } from '../interfaces/IUserAuthenticationService.interface';
export class AuthAction {
    constructor(public name: string, public service: IUserAuthenticationService, public authResult: (username: string, level: string, success: boolean) => void) {}
}